import { createI18n } from 'vue-i18n';

import en from './en.json';
import sr from './sr.json';

const i18n = createI18n({
  locale: 'sr',
  fallbackLocale: 'sr',
  messages: { sr, en },
  legacy: false
});

export const t = i18n.global.t;
export const te = i18n.global.te;

export default i18n;
